import React, { FormEvent, useCallback, useContext, useEffect, useState } from 'react'
import { BsFillTrashFill } from 'react-icons/bs'
import { FiEdit3 } from 'react-icons/fi'
import { AdminForm } from '../../components/AdminForm'
import { HeaderPage } from '../../components/HeaderPage'
import AdminUserContext from '../../context/AdminUser'
import useApi from '../../hooks/useApi'
import { Button } from '../../Korbantech/components/Buttons/Button'
import { SubmitButton } from '../../Korbantech/components/Buttons/SubmitButton'
import Modal from '../../Korbantech/components/Modal'
import { AdminLayout } from '../../layout/AdminLayout'
import { AdminUser as Type } from '../../types/AdminUser'

export const AdminUser = () => {

    const [users, setUsers] = useState<Type[]>([])
    const [userCurrrent, setUserCurrent] = useState<Type|undefined>()

    const [open,setOpen] = useState<boolean>(false)
    const [openDelete,setOpenDelete] = useState<boolean>(false)
    const { state: user } = useContext( AdminUserContext )
    const api = useApi()

    const selectUser = useCallback((user:Type,isDelete?:boolean)=>{
            setUserCurrent(user)
            if(isDelete) setOpenDelete(true)
            if(!isDelete) setOpen(true)
    },[])

    const openModalNew = () => {
        setUserCurrent(undefined)
        setOpen(true)
    }
    
    const loadUsers = useCallback(async ()=>{
        await api.get('/admin/admin-users').then(res=>{
            setUsers(res.data)
        }).catch(console.log)
    },[api,setUsers])

    const handleSubmit = useCallback(async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        e.currentTarget.checkValidity()

        if (!e.currentTarget) return
        const data = new FormData(e.currentTarget)

        if (userCurrrent) {
            data.append('_method', 'PATCH')
            return await api.post(`/admin/admin-users/${userCurrrent.id}`, data).then(res => {
                window.location.reload()
            }).catch(console.log)
            
        }

        await api.post("/admin/admin-users", data).then(res => {
            window.location.reload();
        }).catch(console.log)

    }, [api, userCurrrent])

    
    const handleDelete = useCallback(async (user:Type) => {
        await api.delete(`/admin/admin-users/${user.id}`).then(res => {
            window.location.reload()
        }).catch(console.log)
    }, [api])
 

    useEffect(()=>{
        loadUsers()
    },[loadUsers])

    return (
        <AdminLayout>
            <HeaderPage name='Usuários' button={user?.is_super_admin ?
                  <Button value={"Novo usuário"} onClick={()=>openModalNew()}/>
                  :''
                } />
            <div className='grid grid-cols-3 gap-4'>
                {users?.map(item => (
                    <div key={item.id} className={`bg-white rounded-md p-3 border-l-4 ${item.is_super_admin? "border-primary" : "border-green-500"} 
                            overflow-hidden flex justify-between`}
                            onClick={()=>selectUser(item)}
                    >
                        <div className=''>
                            <div><strong>Nome: </strong>{item?.name}</div>
                            <div><strong>Email: </strong>{item?.email}</div>
                            {item?.is_super_admin ? <strong className='text-green-500'>Admin</strong> : ""}
                        </div>
                        {user?.is_super_admin ?  <div className='flex flex-col gap-y-2'>
                                <FiEdit3 className='mr-1 cursor-pointer text-green-500' onClick={()=>selectUser(item)}/>
                                <BsFillTrashFill className='mr-1 cursor-pointer text-red-500' onClick={()=>selectUser(item,true)}/>
                        </div> : ""}            
                    </div>
                ))}
                <Modal open={open} onClickCloseButton={()=>setOpen(false)}>
                        <form onSubmit={handleSubmit}>
                            <AdminForm user={userCurrrent} />
                            <SubmitButton value={userCurrrent ? "Alterar" : "Salvar"} />
                        </form>
                </Modal>
                <Modal open={openDelete} onClickCloseButton={()=>setOpenDelete(false)}>
                    {userCurrrent &&
                <div className='flex flex-col p-2'>
                    <strong>Deseja mesmo deletar o item :</strong>
                            {userCurrrent.name}
                        <div className='flex justify-between gap-x-2'>
                            <button className='bg-primary-dark mt-3 py-1 px-2 rounded-md' onClick={() => setOpenDelete(false)}>
                                        Cancelar
                            </button>
                            <button className='bg-red-500 mt-3 py-1 px-2 rounded-md text-white' onClick={() => handleDelete(userCurrrent)}>
                                        Confirmar e deletar
                            </button>
                        </div>
                    

                </div>
}
                </Modal>
            </div>
        </AdminLayout>
    )
}

